import * as React from "react";
import { selectResourceAmountInfo } from "../../../../balancingSelectors/selectBalancingResources";
import { IdTooltipAdjust } from "../../../../constants/IdTooltipAdjust";
import { IdStyles } from "../../../../less/IdStyles";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { Icon } from "../../../generic/icon/Icon";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { ResourceIcon } from "../../../generic/icon/ResourceIcon";
import { NumberFormat } from "../../../generic/number-format/NumberFormat";
import { TextLoca } from "../../../generic/text/TextLoca";
import { IdTooltipAnchor, TooltipText } from "../../../tooltip";
export var QuestItemRewards = function (_a) {
    var quest = _a.quest, isCompleted = _a.isCompleted;
    var xp = getXp(quest.xp);
    var rewards = quest.resourceReward
        ? quest.resourceReward.map(function (val) {
            var awardedResource = selectResourceAmountInfo(val.resourceId, val.amount);
            return (React.createElement("div", { key: awardedResource.locaKey, className: "flex flex--aligned flex--guts" },
                React.createElement(ResourceIcon, { resource: awardedResource, styleId: IdStyles.IconExtraLarge, tooltipVerticalAdjust: IdTooltipAdjust.Small },
                    React.createElement("div", { className: "flex h100 w100 flex--stacked flex--end" },
                        React.createElement(NumberFormat, { amount: awardedResource.amount, className: IdStyles.TextBoldSecondaryOutline })))));
        })
        : undefined;
    return (React.createElement("div", { className: (isCompleted
            ? IdStyles.QuestRewardsBackgroundCompleted
            : IdStyles.QuestRewardsBackground) + " quest-item-reward__container" },
        React.createElement("div", { className: "title " + IdStyles.TextBoldAccent },
            React.createElement(TextLoca, { id: IdLoca.rewards })),
        React.createElement("div", { className: "reward" },
            rewards,
            xp)));
};
var getXp = function (xp) {
    if (xp) {
        return (React.createElement("div", { className: "flex flex--aligned flex--guts" },
            React.createElement(TooltipText, { id: IdLoca.tooltip_playerXp_web, anchor: IdTooltipAnchor.Bottom },
                React.createElement(Icon, { icon: IdIcon.XpIcn + " flex flex--bottom flex--centered", styleId: IdStyles.IconExtraLarge },
                    React.createElement(NumberFormat, { amount: xp.amount, className: IdStyles.TextBoldSecondaryOutline })))));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestItemRewards.tsx
// module id = 2663
// module chunks = 3